import { useNavigate } from "react-router-dom";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  LineChart,
  Line,
  PieChart,
  Pie,
  Cell,
  Legend
} from "recharts";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, IconButton, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

const earningsData = [
  { name: "Mon", earnings: 1200 },
  { name: "Tue", earnings: 2100 },
  { name: "Wed", earnings: 1800 },
  { name: "Thu", earnings: 3000 },
  { name: "Fri", earnings: 2600 },
  { name: "Sat", earnings: 3400 },
  { name: "Sun", earnings: 2700 },
];

const bookingsData = [
  { name: "Mon", bookings: 12 },
  { name: "Tue", bookings: 21 },
  { name: "Wed", bookings: 18 },
  { name: "Thu", bookings: 30 },
  { name: "Fri", bookings: 26 },
  { name: "Sat", bookings: 40 },
  { name: "Sun", bookings: 35 },
];

const clientsData = [
  { name: "New", value: 45 },
  { name: "Returning", value: 55 },
];
const COLORS = ['#D3B88C', '#282828'];

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title d_flex">
        <h1>Dashboard</h1>
        <div className="right_s">
          <div className="form">
            <Select fullWidth value={"default"}>
              <MenuItem disabled value="default">Select Time Period</MenuItem>
              <MenuItem value="Abu Dhabi">Today</MenuItem>
              <MenuItem value="Dubai">Last 7 Days</MenuItem>
              <MenuItem value="Sharjah">Last 30 Days</MenuItem>
              <MenuItem value="Ajman">Last 3 Months</MenuItem>
              <MenuItem value="Umm al-Quwain">Last Year</MenuItem>
            </Select>
          </div>
          <div className="form">
            <Select fullWidth value={"default"}>
              <MenuItem disabled value="default">Service Selector</MenuItem>
              <MenuItem value="Abu Dhabi">Service 1</MenuItem>
              <MenuItem value="Dubai">Service 2</MenuItem>
            </Select>
          </div>
        </div>
      </div>
      <div className="stats_boxes gap_m">
        <div className="cards">
          <figure className="sucess">
            <img src="/static/images/bag.svg" alt="Total Earnings" />
          </figure>
          <h2>AED 15,400</h2>
          <p>Total Earnings</p>
          <div className="rating_box">
            <p>
              <span><ArrowUpwardIcon /> +12%</span>
              this month
            </p>
          </div>
        </div>

        <div className="cards">
          <figure className="active_order">
            <img src="/static/images/active_order.svg" alt="Number of Bookings" />
          </figure>
          <h2>248</h2>
          <p>Number of Bookings</p>
          <div className="rating_box">
            <p>
              <span><ArrowUpwardIcon /> +8</span>
              this month
            </p>
          </div>
        </div>

        <div className="cards">
          <figure className="warning">
            <img src="/static/images/reward_icon.svg" alt="Completion Rate" />
          </figure>
          <h2>92%</h2>
          <p>Completion Rate</p>
          <div className="rating_box">
            <p>
              <span><ArrowUpwardIcon /> +2%</span>
              this month
            </p>
          </div>
        </div>
        <div className="cards">
          <figure className="blue">
            <img src="/static/images/star.svg" alt="Average Rating" />
          </figure>
          <h2>4.8</h2>
          <p>Average Rating (124 reviews)</p>
          <div className="rating_box">
            <p>
              <span><ArrowUpwardIcon /> +0.2</span>
              this month
            </p>
          </div>
        </div>

        <div className="cards">
          <figure className="sucess">
            <img src="/static/images/bag.svg" alt="New Clients" />
          </figure>
          <h2>45</h2>
          <p>New Clients</p>
          <div className="rating_box">
            <p>
              <span><ArrowUpwardIcon /> +15</span>
              this month
            </p>
          </div>
        </div>

        <div className="cards">
          <figure className="active_order">
            <img src="/static/images/active_order.svg" alt="Repeat Clients %" />
          </figure>
          <h2>38%</h2>
          <p>Repeat Clients</p>
          <div className="rating_box">
            <p>
              <span><ArrowUpwardIcon /> +5%</span>
              this month
            </p>
          </div>
        </div>
      </div>
      <div className="grid_sc gap_m">
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Earnings Trend</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span className="active">A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={earningsData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="earnings" stroke="#D3B88C" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </div>
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Bookings Trend</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span className="active">A month</span>
                <span>A year</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={bookingsData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="bookings" fill="#D3B88C" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>New vs Returning Clients</h2>
            </div>
            <div className="right_s">
              <p>
                <span className="active">This month</span>
              </p>
            </div>
          </div>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={clientsData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                fill="#8884d8"
                paddingAngle={5}
                dataKey="value"
              >
                {clientsData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="cards table_card">
          <div className="cards_header">
            <div className="left_s">
              <h2>Light Insights</h2>
            </div>
          </div>
          <div className="insights_list mt_20">
            <ul style={{ listStyle: 'none', padding: '10px 0', margin: 0, display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <li style={{ padding: '15px', background: '#fcfaf6', borderRadius: '8px', borderLeft: '4px solid #D3B88C' }}>
                <p style={{ margin: 0, color: '#333', fontSize: '15px' }}>Your bookings this month are <strong>12% higher</strong> than last month.</p>
              </li>
              <li style={{ padding: '15px', background: '#fcfaf6', borderRadius: '8px', borderLeft: '4px solid #D3B88C' }}>
                <p style={{ margin: 0, color: '#333', fontSize: '15px' }}>You received <strong>3 new reviews</strong> in the last 7 days.</p>
              </li>
              <li style={{ padding: '15px', background: '#fcfaf6', borderRadius: '8px', borderLeft: '4px solid #D3B88C' }}>
                <p style={{ margin: 0, color: '#333', fontSize: '15px' }}>You have <strong>2 bookings</strong> this weekend.</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="cards table_card mt_20">
        <div className="sub_hd">
          <h3>Upcoming Bookings</h3>
        </div>
        <div className="table_wrap w_100">
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date & Time</TableCell>
                  <TableCell>Service Name</TableCell>
                  <TableCell>Client Name</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow hover>
                  <TableCell>Oct 24, 2024 • 10:00 AM</TableCell>
                  <TableCell>Signature Facial</TableCell>
                  <TableCell>Sarah Jenkins</TableCell>
                  <TableCell><span className="badge badge-success">Confirmed</span></TableCell>
                  <TableCell>
                    <Box display="flex" gap={1}>
                      <IconButton onClick={() => navigate("/order-management/view")}>
                        <img
                          src="/static/images/eye_icon.svg"
                          alt="Edit"
                          style={{ width: "22px", height: "22px" }}
                        />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>Oct 24, 2024 • 02:30 PM</TableCell>
                  <TableCell>Deep Cleansing Massage</TableCell>
                  <TableCell>Michael Chang</TableCell>
                  <TableCell><span className="badge badge-warning">Pending</span></TableCell>
                  <TableCell>
                    <Box display="flex" gap={1}>
                      <IconButton onClick={() => navigate("/order-management/view")}>
                        <img
                          src="/static/images/eye_icon.svg"
                          alt="Edit"
                          style={{ width: "22px", height: "22px" }}
                        />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>Oct 25, 2024 • 11:15 AM</TableCell>
                  <TableCell>Laser Hair Removal</TableCell>
                  <TableCell>Emily Roberts</TableCell>
                  <TableCell><span className="badge badge-info">Rescheduled</span></TableCell>
                  <TableCell>
                    <Box display="flex" gap={1}>
                      <IconButton onClick={() => navigate("/order-management/view")}>
                        <img
                          src="/static/images/eye_icon.svg"
                          alt="Edit"
                          style={{ width: "22px", height: "22px" }}
                        />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>Oct 25, 2024 • 04:00 PM</TableCell>
                  <TableCell>Bridal Makeup Trial</TableCell>
                  <TableCell>Jessica Thompson</TableCell>
                  <TableCell><span className="badge badge-success">Confirmed</span></TableCell>
                  <TableCell>
                    <Box display="flex" gap={1}>
                      <IconButton onClick={() => navigate("/order-management/view")}>
                        <img
                          src="/static/images/eye_icon.svg"
                          alt="Edit"
                          style={{ width: "22px", height: "22px" }}
                        />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>

      <section>
        <div className="table_group gap_m table_card mt_20">
          <div className="cards store_list table_card" style={{ flex: 1 }}>
            <div className="sub_hd">
              <h3>Recent Completed Bookings</h3>
            </div>
            <div className="table_wrap w_100">
              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Service</TableCell>
                      <TableCell>Client</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow hover>
                      <TableCell>Oct 23, 2024</TableCell>
                      <TableCell>Hair Coloring</TableCell>
                      <TableCell>Anna Lee</TableCell>
                      <TableCell>AED 450</TableCell>
                      <TableCell><span className="badge badge-success">Completed</span></TableCell>
                    </TableRow>
                    <TableRow hover>
                      <TableCell>Oct 22, 2024</TableCell>
                      <TableCell>Manicure & Pedicure</TableCell>
                      <TableCell>Lisa Wong</TableCell>
                      <TableCell>AED 120</TableCell>
                      <TableCell><span className="badge badge-success">Completed</span></TableCell>
                    </TableRow>
                    <TableRow hover>
                      <TableCell>Oct 21, 2024</TableCell>
                      <TableCell>Hot Stone Massage</TableCell>
                      <TableCell>Oliver Twist</TableCell>
                      <TableCell>AED 300</TableCell>
                      <TableCell><span className="badge badge-success">Completed</span></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          <div className="cards store_list table_card" style={{ flex: 1 }}>
            <div className="sub_hd">
              <h3>Recent Reviews</h3>
            </div>
            <div className="table_wrap w_100">
              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Client</TableCell>
                      <TableCell>Rating</TableCell>
                      <TableCell>Review</TableCell>
                      <TableCell>Service</TableCell>
                      <TableCell>Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow hover>
                      <TableCell>Fatima Al-Zahra</TableCell>
                      <TableCell>⭐⭐⭐⭐⭐</TableCell>
                      <TableCell>"Amazing experience, highly recommend!"</TableCell>
                      <TableCell>Signature Facial</TableCell>
                      <TableCell>Oct 24, 2024</TableCell>
                    </TableRow>
                    <TableRow hover>
                      <TableCell>Michael Chang</TableCell>
                      <TableCell>⭐⭐⭐⭐</TableCell>
                      <TableCell>"Good service but had to wait a bit."</TableCell>
                      <TableCell>Deep Cleansing Massage</TableCell>
                      <TableCell>Oct 22, 2024</TableCell>
                    </TableRow>
                    <TableRow hover>
                      <TableCell>Emily Roberts</TableCell>
                      <TableCell>⭐⭐⭐⭐⭐</TableCell>
                      <TableCell>"The best facial I have ever had!"</TableCell>
                      <TableCell>Signature Facial</TableCell>
                      <TableCell>Oct 21, 2024</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard;
